import { useState } from 'react';
import { AppFormDialog, AppTextField } from '@core/designsystem';

/** Что нужно, чтобы завести клиента. Остальное правится в его карточке. */
export interface ClientDraft {
  fullName: string;
  phone: string | null;
  email: string | null;
}

/**
 * Новый клиент: имя обязательно, телефон и почта — если есть под рукой.
 *
 * Диалог живёт в `core/ui`, а не в разделе клиентов, потому что заводить клиента
 * приходится из трёх мест: из самого списка клиентов, при создании дела и в карточке
 * дела. Юрист заводит дело на клиента, которого в приложении ещё нет, — отправлять его
 * за этим в другой раздел значит терять дело: он уходит и не возвращается. На Android
 * это уже проходили; в вебе повторилось, потому что диалог лежал внутри раздела,
 * а раздел разделу не сосед (правило 1 `check-rules.mjs`).
 */
export function NewClientDialog({
  onDismiss,
  onCreate,
}: {
  onDismiss: () => void;
  onCreate: (draft: ClientDraft) => void;
}) {
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');

  return (
    <AppFormDialog
      title="Новый клиент"
      onDismiss={onDismiss}
      confirm={{
        label: 'Создать',
        enabled: fullName.trim().length > 0,
        onClick: () => onCreate({ fullName, phone: phone || null, email: email || null }),
      }}
    >
      <AppTextField value={fullName} onChange={setFullName} label="Имя или наименование" autoFocus />
      {/*
       * Поле телефона — обычное: узкой клавиатуры здесь нет ([D-26](docs/DECISIONS.md)).
       * Юрист пишет в него и «доб. 214», и пометку рядом с номером.
       */}
      <AppTextField value={phone} onChange={setPhone} label="Телефон" />
      <AppTextField value={email} onChange={setEmail} label="Почта" />
    </AppFormDialog>
  );
}
